import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { Role } from '@models/enums';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private userRolesSubject = new BehaviorSubject<string[]>([]);
  constructor(private readonly keycloak: KeycloakService) {}
  getRole(): Observable<string[]> {
    if (!this.userRolesSubject.getValue().length) {
      const userRoles = this.keycloak.getUserRoles();
      this.updateUserRole(userRoles);
    }
    return this.userRolesSubject.asObservable();
  }
  updateUserRole(roles: string[]) {
    this.userRolesSubject.next(roles);
  }

  canAccess(requiredRoles: Role[]): boolean {
    const currentRoles = this.userRolesSubject.getValue() as Role[];
    return requiredRoles.some((role) => currentRoles.includes(role));
  }

  canAccessLink(link: string): boolean {
    switch (link) {
      case 'ACCUEIL':
        return true;

      case 'RECRUTEMENT':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR]);

      case 'RENOUVELLEMENT':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR]);

      case 'CONSULTATION DES DEMANDES':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR]);

      case 'VALIDATION DES DEMANDES':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR]);

      case "DEMANDES D'AVIS":
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER]);

      case 'CONSULTATION FIN DE CONTRATS':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER]);

      case 'CONSULTATION ANNUAIRE DES POSTES':
        return this.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER]);

      case 'ADMINISTRATION':
        return this.canAccess([Role.PAMA_ADMIN]);

      default:
        return false;
    }
  }
}
